import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import * as SearchAuthorsActions from 'rebook/apps/search/actions/SearchAuthorsActions';
import AuthorList from 'rebook/apps/catalog/components/AuthorList';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BackLink from 'rebook/apps/base/components/BackLink';
import SearchResultEmpty from 'rebook/apps/search/components/SearchResultEmpty';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


class SearchAuthorsView extends React.Component {
  componentDidMount() {
    this.props.SearchAuthorsActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchAuthorsActions.resetData();
  }

  changePage(newPageNumber) {
    this.props.SearchAuthorsActions.fetchAuthors(newPageNumber);
  }

  render() {
    const {
      authorsList, authorsCount, query, pageNumber, lastPageNumber, isLoading,
    } = this.props.searchAuthors;

    return (
      <div className="backgroundContainer themeGrey">
        <div className="section">
          {isLoading && <AuthorList authors={[...Array(5)]} />}
          {!isLoading && !get(authorsList, 'length', 0) && <SearchResultEmpty /> }
          {!isLoading && authorsList && (
            <React.Fragment>
              <BackLink link={`/search/?q=${query}`}
                extraClassName={styles.breadCrumbs}
                isMargined>
                <span className="link">Все результаты</span>
              </BackLink>
              <div className="title-1">
                Все авторы по запросу «{query}»
              </div>
              <small>
                {authorsCount} {pluralize(authorsCount, 'автор', 'автора', 'авторов')}
              </small>
              <AuthorList authors={authorsList} />
              <ContextPagination
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={pageNumber}
                lastPage={lastPageNumber} />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchAuthors: state.searchAuthors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SearchAuthorsActions: bindActionCreators(SearchAuthorsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchAuthorsView);
